import { render, staticRenderFns } from "./star.vue?vue&type=template&id=8fa8b3d2&scoped=true&"
var script = {}
import style0 from "./star.vue?vue&type=style&index=0&id=8fa8b3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa8b3d2",
  null
  
)

export default component.exports